var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicatesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 2.28A2.33 2.33 0 0 0 7.38 0H2.3A2.3 2.3 0 0 0 0 2.33v5.06a2.33 2.33 0 0 0 2.28 2.33A2.33 2.33 0 0 0 4.6 12h5.1A2.3 2.3 0 0 0 12 9.68V4.6a2.33 2.33 0 0 0-2.31-2.33Zm-7.4 2.33v4.16A1.38 1.38 0 0 1 .92 7.4V2.33A1.4 1.4 0 0 1 2.3.93h5.04a1.39 1.39 0 0 1 1.39 1.35H4.6a2.31 2.31 0 0 0-2.33 2.33Zm8.75 5.06a1.4 1.4 0 0 1-1.35 1.4H4.6a1.39 1.39 0 0 1-1.38-1.4V4.61A1.4 1.4 0 0 1 4.6 3.22H9.7a1.39 1.39 0 0 1 1.35 1.4v5.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88 6.68H7.6V5.44a.47.47 0 0 0-.46-.46.46.46 0 0 0-.46.46v1.24H5.37a.46.46 0 0 0-.46.47.47.47 0 0 0 .46.46h1.3v1.24a.47.47 0 0 0 .46.46.46.46 0 0 0 .46-.46V7.6h1.3a.46.46 0 0 0 .46-.46.47.47 0 0 0-.47-.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatesmall);
export default __webpack_public_path__ + "static/media/duplicate.small.338548503c868ed627d1d704dee4f8be.svg";
export { ForwardRef as ReactComponent };